export function normalizeColumnName(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return 'unknown';

  return trimmed
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9_-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

